var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        "content-class":
          "v-application v-application--is-ltr vuetify-wrapper pricing-override-dialog",
        width: "auto",
      },
      model: {
        value: _vm.isOpen,
        callback: function ($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "text-h5" }, [
            _vm._v("\n            Preise Anpassen\n        "),
          ]),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "mt-4 pb-0" },
            _vm._l(_vm.pricingOverrides, function (price, service) {
              return _c("service-price-override", {
                key: service,
                attrs: {
                  service: service,
                  pharmacist: _vm.pricingOverrides[service].pharmacist,
                  pharmacy: _vm.pricingOverrides[service].pharmacy,
                  margin: _vm.margins[service],
                },
                on: {
                  "update:pharmacist": function ($event) {
                    return _vm.$set(
                      _vm.pricingOverrides[service],
                      "pharmacist",
                      $event
                    )
                  },
                  "update:pharmacy": function ($event) {
                    return _vm.$set(
                      _vm.pricingOverrides[service],
                      "pharmacy",
                      $event
                    )
                  },
                  "update:margin": function ($event) {
                    return _vm.$set(_vm.margins, service, $event)
                  },
                },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "mb-3" },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { text: "", outlined: "" },
                  on: {
                    click: function ($event) {
                      _vm.isOpen = false
                    },
                  },
                },
                [_vm._v("\n                Abbrechen\n            ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "ml-4 save-btn",
                  attrs: {
                    loading: _vm.isLoading,
                    color: "primary",
                    disabled: !_vm.appointmentIds.length,
                    depressed: "",
                  },
                  on: { click: _vm.submit },
                },
                [_vm._v("\n                Speichern\n            ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }